<template>
  <b-card
    v-if="superUser"
    :loading="loading"
    :cancelBtn="false"
    :topCancelBtn="false"
    :submitText="translations.save"
    @submit="submitSettings()"
  >
    <v-card-title
      ><span class="text-h5 pl-1 pb-0">{{ translations.notifications[lang] }}</span></v-card-title
    >
    <v-col class="d-flex justify-center transition-all align-center select-btn-container">
      <span class="select-btn-text">{{ translations.selectNotificationChannel[lang] }}:</span>

      <v-btn-toggle
        class="ma-4"
        v-model="smsBtn"
        dense
        group
        @change="changeNotificationSettings('sms_notification', smsBtn)"
      >
        <v-card :flat="campaign.settings.sms_notification || true">
          <v-btn
            style="box-shadow: none"
            :color="campaign.settings.sms_notification ? 'success' : 'error'"
          >
            <v-icon>{{
              campaign.settings.sms_notification ? 'mdi-check-circle' : 'mdi-cancel'
            }}</v-icon>
            <span class="ml-3">Sms</span>
          </v-btn>
        </v-card>
      </v-btn-toggle>
      <v-btn-toggle
        class="ma-4"
        v-model="emailBtn"
        dense
        group
        @change="changeNotificationSettings('email_notification', emailBtn)"
      >
        <v-card :flat="campaign.settings.email_notification || true">
          <v-btn
            style="box-shadow: none"
            :color="campaign.settings.email_notification ? 'success' : 'error'"
          >
            <v-icon>{{
              campaign.settings.email_notification ? 'mdi-check-circle' : 'mdi-cancel'
            }}</v-icon>
            <span class="ml-3">Email</span>
          </v-btn>
        </v-card>
      </v-btn-toggle>
    </v-col>
    <v-col class="d-flex justify-center transition-all align-center select-btn-container mb-4">
      <span class="select-btn-text">{{ translations.selectFrequency[lang] }}:</span>

      <v-btn-toggle class="ma-4" v-model="frequencyBtn" dense group mandatory>
        <!-- {{ smsBtn }} -->
        <v-card
          v-for="(item, index) in frequencyItems"
          :key="index"
          :flat="index == frequencyBtn || true"
        >
          <v-btn style="box-shadow: none" @click="changeFrequency(item)">
            <v-icon>{{ index == frequencyBtn ? 'mdi-check-circle' : 'mdi-circle-outline' }}</v-icon>
            <span v-if="item" class="ml-3">{{ translations[item][lang] }}</span>
          </v-btn>
        </v-card>
      </v-btn-toggle>
    </v-col>
    <v-divider></v-divider>
    <v-row class="pb-6 mt-0">
      <v-col cols="12" md="12" class="d-flex">
        <span class="text-h5 pa-6 pl-4 pb-0">{{ translations.transactionSettings[lang] }}</span>
      </v-col>
      <v-col cols="12" md="12">
        <v-col cols="12" md="6" sm="12" lg="4" xl="3" style="margin-left: 3%">
          <b-text-field
            v-model="campaign.settings.transaction_minimum_price"
            :label="translations.minAmmount[lang]"
            :success="amountError.hasError === false"
            :error-messages="amountError.hasError ? amountError.txt[lang] : ''"
            @focus="amountError.hasError = null"
            @blur="validateAmount"
          ></b-text-field>
        </v-col>
      </v-col>
    </v-row>
    <div v-if="campaign.report_url && campaign.report_url !== '-'">
      <v-divider></v-divider>
      <v-row class="pb-0 mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-card flat style="min-width: 150px" class="d-flex align-center"
            ><span class="text-body-2">{{ translations.reportUrl[lang] }}:</span>
          </v-card>
          <v-list-item :href="campaign.report_url" target="_blank">
            {{ campaign.report_url }}
          </v-list-item>
        </v-col>
      </v-row>
    </div>
  </b-card>
</template>

<script>
import {
  mdiClose,
  mdiBell,
  mdiCash,
  mdiGift,
  mdiAccount,
  mdiCheckCircle,
  mdiCloseCircle,
  mdiGiftOutline,
  mdiTicketPercentOutline,
  mdiStore,
  mdiDomain,
  mdiPencilOutline,
  mdiContentSave,
} from '@mdi/js';

import translations from '@/utils/translations/loyaltyPanel/campaigns/viewCampaigns';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'PerformanceInfo',

  mixins: [translations],

  data: () => ({
    icons: {
      mdiClose,
      mdiBell,
      mdiCash,
      mdiGift,
      mdiAccount,
      mdiCheckCircle,
      mdiCloseCircle,
      mdiGiftOutline,
      mdiTicketPercentOutline,
      mdiStore,
      mdiDomain,
      mdiPencilOutline,
      mdiContentSave,
    },
    onboarding: 0,
    smsBtn: null,
    emailBtn: null,
    frequencyItems: ['daily', 'weekly', 'monthly'],
    frequencyBtn: null,
    amountError: {
      hasError: null,
      txt: {
        el: 'Πρέπει να είναι έγκυρος αριθμός ίσος ή μεγαλύτερος από το μηδέν',
        en: 'Must be a valid number equal to or greater than zero',
        it: 'Deve essere un numero valido uguale o maggiore di zero',
      },
    },
  }),

  computed: {
    ...mapState(['loading', 'superUser']),

    lang() {
      return this.$route.params.lang;
    },

    locale() {
      if (this.lang == 'el') return 'el-GR';
      if (this.lang == 'it') return 'it-IT';
      return 'en-GB';
    },

    ...mapGetters('loyaltyPanel/campaigns/viewCampaigns', ['campaign']),

    settingsAreValid() {
      if (this.amountError.hasError !== false) {
        return false;
      }
      if (!this.frequencyItems.includes(this.campaign.settings.notification_frequency)) {
        return false;
      }

      return true;
    },
  },
  methods: {
    ...mapMutations(['setNotification']),

    ...mapActions('loyaltyPanel/campaigns/viewCampaigns', ['updateCampaignSettings']),

    next() {
      this.onboarding = this.onboarding + 1 === this.sections.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding = this.onboarding - 1 < 0 ? this.sections.length - 1 : this.onboarding - 1;
    },
    localizeDate(date) {
      return date
        ? new Date(date).toLocaleString(this.locale, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
        : '';
    },
    changeNotificationSettings(setting, btnVal) {
      this.campaign.settings[setting] = btnVal !== undefined;
    },
    changeFrequency(btnVal) {
      this.campaign.settings.notification_frequency = btnVal || this.frequencyItems[0];
    },
    validateAmount() {
      this.amountError.hasError = false;
      let amount = this.campaign.settings.transaction_minimum_price;
      if (isNaN(amount)) {
        this.amountError.hasError = true;
      }
      if (amount !== 0 && !amount) {
        this.amountError.hasError = true;
      }
      if (amount < 0) {
        this.amountError.hasError = true;
      }
    },
    async submitSettings() {
      this.validateAmount();
      if (!this.settingsAreValid) {
        return this.setNotification({
          show: true,
          type: 'error',
          text: this.translations.checkValues[this.lang],
        });
      }
      let res = await this.updateCampaignSettings({
        campaign_id: this.campaign.campaign_id,
        body: this.campaign.settings,
      });
      if (res?.data && !res.data.error) {
        this.setNotification({
          show: true,
          type: 'success',
          text: this.translations.settingsUpdated[this.lang],
        });
      }
    },
  },
  mounted() {
    this.smsBtn = this.campaign.settings.sms_notification ? 0 : undefined;
    this.emailBtn = this.campaign.settings.email_notification ? 0 : undefined;
    this.frequencyBtn =
      this.frequencyItems.findIndex((x) => x == this.campaign.settings.notification_frequency) || 0;
  },

  watch: {},
};
</script>

<style>
.mention-str {
  background: #3a4258;
  color: aliceblue;
  padding: 2px 10px;
  text-align: center;
  border-radius: 6px;
  border: 1px solid white;
}

.mentionable-input .v-input {
  font-size: 0.98rem;
  line-height: 1.75rem;
}

.transition-all {
  transition:
    all 0.5s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 2s,
    background-color 0.8s;
}
.transition-all * {
  transition:
    all 0.5s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 2s,
    background-color 0.8s;
}
.select-btn-container {
  position: relative;
}
.select-btn-text {
  position: absolute;
  left: 25px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 3%;
}
</style>
